import React from "react";
import { Link } from "react-router-dom";
import { FaLinkedin, FaInstagram } from "react-icons/fa";
import "./footer.css";

const productLinks = [
  { title: "Job Seekers", to: "/job-seekers" },
  { title: "Career Centers", to: "/career-centers" },
  { title: "Pricing", to: "/pricing" },
  { title: "Insights", to: "/insights" },
  { title: "About Us", to: "/about" },
];

const communityLinks = [
  { title: "Ambassadors", to: "/ambassador-program" },
];

const legalLinks = [
  { title: "Terms of Service", href: "https://app.raincareers.com/terms-and-conditions" },
  { title: "Privacy Policy", href: "https://app.raincareers.com/privacy-policy" },
  { title: "Accessibility", href: "https://app.raincareers.com/accessibility" },
];

const Footer = () => {
  return (
    <footer className="site-footer">
      <div className="footer-inner">
        <div className="footer-columns">
          {/* Product */}
          <div className="footer-column">
            <span className="footer-col-heading">Product</span>
            {productLinks.map((link) => (
              <Link key={link.title} to={link.to} className="footer-link">
                {link.title}
              </Link>
            ))}
          </div>

          {/* Community */}
          <div className="footer-column">
            <span className="footer-col-heading">Community</span>
            {communityLinks.map((link) => (
              <Link key={link.title} to={link.to} className="footer-link">
                {link.title}
              </Link>
            ))}
          </div>

          {/* Legal */}
          <div className="footer-column">
            <span className="footer-col-heading">Legal</span>
            {legalLinks.map((link) => (
              <a
                key={link.title}
                href={link.href}
                className="footer-link"
                target="_blank"
                rel="noopener noreferrer"
              >
                {link.title}
              </a>
            ))}
          </div>

          {/* Social */}
          <div className="footer-column">
            <span className="footer-col-heading">Follow Us</span>
            <a
              href="https://www.linkedin.com/company/raincareers/"
              className="footer-link footer-social-link"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaLinkedin size={14} />
              LinkedIn
            </a>
            <a
              href="https://www.instagram.com/raincareers/"
              className="footer-link footer-social-link"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaInstagram size={14} />
              Instagram
            </a>
          </div>
        </div>

        <div className="footer-bottom">
          <span className="footer-copy">
            © {new Date().getFullYear()} RAIN Careers, Inc. All rights reserved.
          </span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
